document.documentElement.classList.remove('no-js');

function fsnOrganizeProducts() {
  const seen = new Set();
  const sections = document.querySelectorAll('[data-fsn-product-section]');

  sections.forEach((section) => {
    const batch = Number.parseInt(section.getAttribute('data-fsn-max-visible') || '999', 10);
    const currentLimit = Number.parseInt(section.getAttribute('data-fsn-current-visible') || String(batch), 10);
    const dedupe = section.getAttribute('data-fsn-dedupe') === 'true';
    const cards = Array.from(section.querySelectorAll('.fsn-product-card[data-fsn-product-handle]'));
    const eligible = [];

    cards.forEach((card) => {
      const handle = card.getAttribute('data-fsn-product-handle');
      const duplicate = dedupe && handle && seen.has(handle);
      card.removeAttribute('data-fsn-hidden-limit');
      card.removeAttribute('data-fsn-hidden-dedupe');

      if (duplicate) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('data-fsn-hidden-dedupe', 'true');
        return;
      }

      if (dedupe && handle) seen.add(handle);
      eligible.push(card);
    });

    eligible.forEach((card, index) => {
      if (index >= currentLimit) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('data-fsn-hidden-limit', 'true');
      } else {
        card.hidden = false;
        card.removeAttribute('aria-hidden');
      }
    });

    const visibleCount = Math.min(currentLimit, eligible.length);
    section.setAttribute('data-fsn-visible-products', String(visibleCount));

    if (visibleCount === 0 && !(window.Shopify && window.Shopify.designMode)) {
      section.hidden = true;
    } else {
      section.hidden = false;
    }

    let loadWrap = section.querySelector('.fsn-load-more-products-wrap');
    if (eligible.length > currentLimit) {
      if (!loadWrap) {
        loadWrap = document.createElement('div');
        loadWrap.className = 'fsn-load-more-products-wrap';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fsn-load-more-products';
        button.textContent = 'CARGAR MÁS PRODUCTOS';
        button.addEventListener('click', () => {
          const now = Number.parseInt(section.getAttribute('data-fsn-current-visible') || String(batch), 10);
          section.setAttribute('data-fsn-current-visible', String(now + batch));
          fsnOrganizeProducts();
        });
        loadWrap.appendChild(button);
        const carouselWrap = section.querySelector('.fsn-carousel-wrap');
        if (carouselWrap) carouselWrap.insertAdjacentElement('afterend', loadWrap);
        else section.appendChild(loadWrap);
      }
    } else if (loadWrap) {
      loadWrap.remove();
    }
  });
}

function fsnInitAutoCarousels() {
  document.querySelectorAll('.fsn-carousel').forEach((carousel) => {
    if (carousel.dataset.fsnAutoInit === 'true') return;
    carousel.dataset.fsnAutoInit = 'true';
    let paused = false;

    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => {
      carousel.addEventListener(evt, () => { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach((evt) => {
      carousel.addEventListener(evt, () => { paused = false; }, { passive: true });
    });

    window.setInterval(() => {
      if (paused) return;
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth - 4);
      if (maxScroll <= 0) return;
      const step = Math.max(280, Math.round(carousel.clientWidth * 0.82));
      if (carousel.scrollLeft >= maxScroll) carousel.scrollTo({ left: 0, behavior: 'smooth' });
      else carousel.scrollBy({ left: step, behavior: 'smooth' });
    }, 5200);
  });
}

function fsnBoot() {
  fsnOrganizeProducts();
  fsnInitAutoCarousels();
}

document.addEventListener('DOMContentLoaded', fsnBoot);
document.addEventListener('shopify:section:load', fsnBoot);
document.addEventListener('shopify:section:reorder', fsnBoot);

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-mobile-menu-toggle]');
  if (menuButton) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) { const open = nav.classList.toggle('is-open'); menuButton.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  }



  const mobileParentLink = event.target.closest('.fsn-nav-item.has-dropdown > a');
  if (mobileParentLink && window.matchMedia('(max-width: 760px)').matches) {
    const item = mobileParentLink.parentElement;
    event.preventDefault();
    const wasOpen = item.classList.contains('is-expanded');
    document.querySelectorAll('.fsn-nav-item.has-dropdown.is-expanded').forEach((other) => {
      if (other !== item) other.classList.remove('is-expanded');
    });
    item.classList.toggle('is-expanded', !wasOpen);
  }

  const scrollButton = event.target.closest('[data-carousel-dir]');
  if (scrollButton) {
    const id = scrollButton.getAttribute('data-carousel-target');
    const carousel = document.getElementById(id);
    if (!carousel) return;
    const dir = scrollButton.getAttribute('data-carousel-dir') === 'next' ? 1 : -1;
    carousel.scrollBy({ left: dir * Math.max(320, carousel.clientWidth * 0.75), behavior: 'smooth' });
  }
});

/* FSN WOW FEATURES — Smart Finder + Wishlist + recently viewed */
(function(){
  const WKEY='fsn_wishlist_v1';
  const RKEY='fsn_recent_v1';

  function read(key){
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch(e){ return []; }
  }
  function write(key,value){
    try { localStorage.setItem(key, JSON.stringify(value)); } catch(e){}
  }

  function wishlist(){
    const items=read(WKEY);
    document.querySelectorAll('[data-fsn-wishlist]').forEach(btn=>{
      const active=items.some(x=>String(x.id)===String(btn.dataset.productId));
      btn.classList.toggle('is-saved',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
      btn.textContent=active?'♥':'♡';
    });
    const count=document.querySelector('[data-fsn-wishlist-count]');
    if(count) count.textContent=items.length;
    const drawer=document.querySelector('[data-fsn-wishlist-drawer]');
    const list=document.querySelector('[data-fsn-wishlist-list]');
    if(list){
      list.innerHTML=items.length ? items.map(x=>`<a href="${x.url}"><span>${x.title}</span><small>Ver producto →</small></a>`).join('') : '<p class="fsn-wishlist-empty">Tu lista está vacía. Guarda productos con ♡ para tenerlos a mano.</p>';
    }
    if(drawer) drawer.hidden=drawer.getAttribute('data-open')!=='true';
  }

  function recent(){
    const cards=document.querySelectorAll('.fsn-product-card[data-fsn-product-id]');
    cards.forEach(card=>{
      const link=card.querySelector('.fsn-product-card__title, .fsn-product-card__media');
      if(!link || link.dataset.fsnRecentBound) return;
      link.dataset.fsnRecentBound='true';
      link.addEventListener('click',()=>{
        const item={id:card.dataset.fsnProductId,title:card.querySelector('.fsn-product-card__title')?.textContent.trim()||'Producto',url:link.href};
        const items=read(RKEY).filter(x=>String(x.id)!==String(item.id));
        write(RKEY,[item,...items].slice(0,6));
      });
    });
  }

  function finder(){
    const box=document.querySelector('[data-fsn-finder-result]');
    if(!box || box.dataset.ready) return;
    box.dataset.ready='true';
    const copy={
      muscle:'Explora proteínas, creatina y opciones para acompañar tus entrenamientos.',
      fat:'Descubre opciones orientadas a definición, control de peso y una rutina sostenible.',
      performance:'Encuentra productos para acompañar sesiones exigentes, energía y recuperación.',
      health:'Explora vitaminas, minerales y productos para completar tu rutina de bienestar.'
    };
    document.querySelectorAll('[data-fsn-goal]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        document.querySelectorAll('[data-fsn-goal]').forEach(b=>{b.classList.remove('is-active');b.setAttribute('aria-selected','false');});
        btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
        const title=document.querySelector('[data-fsn-finder-title]');
        const text=document.querySelector('[data-fsn-finder-copy]');
        const link=document.querySelector('[data-fsn-finder-link]');
        if(title) title.textContent=btn.dataset.fsnLabel;
        if(text) text.textContent=copy[btn.dataset.fsnGoal]||'Descubre una selección de FSN pensada para tu objetivo.';
        if(link) link.href=`/search?q=${btn.dataset.fsnQuery}&type=product`;
      });
    });
  }

  function wishlistUI(){
    if(document.querySelector('[data-fsn-wishlist-drawer]')) return;
    const wrap=document.createElement('div');
    wrap.innerHTML=`<button class="fsn-wishlist-fab" type="button" data-fsn-wishlist-open aria-label="Abrir mi lista">♡ <span data-fsn-wishlist-count>0</span></button>
      <aside class="fsn-wishlist-drawer" data-fsn-wishlist-drawer data-open="false" hidden aria-label="Mi lista de favoritos">
        <div class="fsn-wishlist-head"><div><span>FSN LISTA</span><strong>Mis favoritos</strong></div><button type="button" data-fsn-wishlist-close aria-label="Cerrar">×</button></div>
        <div data-fsn-wishlist-list></div>
      </aside>`;
    document.body.appendChild(wrap);
    document.addEventListener('click',e=>{
      const btn=e.target.closest('[data-fsn-wishlist]');
      if(btn){
        const items=read(WKEY), id=String(btn.dataset.productId), exists=items.some(x=>String(x.id)===id);
        const next=exists?items.filter(x=>String(x.id)!==id):[{id:btn.dataset.productId,title:btn.dataset.productTitle,url:btn.dataset.productUrl},...items];
        write(WKEY,next); wishlist();
      }
      if(e.target.closest('[data-fsn-wishlist-open]')){
        const d=document.querySelector('[data-fsn-wishlist-drawer]'); d.hidden=false; d.setAttribute('data-open','true');
      }
      if(e.target.closest('[data-fsn-wishlist-close]')){
        const d=document.querySelector('[data-fsn-wishlist-drawer]'); d.setAttribute('data-open','false'); d.hidden=true;
      }
    });
    wishlist();
  }

  const oldBoot=window.fsnBoot;
  window.fsnBoot=function(){
    if(typeof oldBoot==='function') oldBoot();
    wishlistUI(); wishlist(); recent(); finder();
  };
  document.addEventListener('DOMContentLoaded',()=>{ wishlistUI(); wishlist(); recent(); finder(); });
})();
